import { useUserStore } from '@/store/userStore'

export default function ({ store, redirect }) {
  const userStore = useUserStore()

  if (userStore.loggedIn && !isSuperadmin(store.state.users.user)) {
    return redirect('/forbidden')
  }
}

// Vistas abiertas solo para 'superadmin'
function isSuperadmin(user) {
  return user && user.role && user.role === 'superadmin'
}
